export default __webpack_public_path__ + "static/media/DEI.6d44cdeb.png";